import { request } from '@umijs/max';
import { RequestType } from '@/interface';
import { accountInfoType } from '@/pages/AccountInfo/interface';

interface AccountInfoRequestType<T> {
  list: T;
  pagination: {
    currentPage: number;
    pageSize: number;
    total: number;
  };
}

export const queryAccountInfo = async (data: { ownerId?: string }) => {
  return request<
    Promise<RequestType<AccountInfoRequestType<Array<accountInfoType>>>>
  >('/api/property/accountDetail/getList', {
    method: 'POST',
    data,
  });
};
